import { employeeGroupLegalEntity } from 'modules/core/store/collections/legalEntities'
import type LegalEntity from 'modules/core/store/models/LegalEntity'

import { employeeEmployeeGroup } from 'modules/employees/store/collections/employeeEmployeeGroup'
import type Employee from 'modules/employees/store/models/Employee'

export const employeeLegalEntity = (employee: Employee): LegalEntity => {
  return employeeGroupLegalEntity(employeeEmployeeGroup(employee))
}

export const employeeLegalEntityId = (employee: Employee): number => {
  return employeeEmployeeGroup(employee).attributes.legal_entity_id
}
